// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:1920px){img[data-v-73ac4d14]{height:240px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
